import {createReducer} from "redux-act";
import {
	clearPlayerPoolState,
	setIsOpenPlayerPool,
	setPlayerPoolFilterPosition,
	updatePlayerPoolFilters,
} from "modules/actions";
import {PlayerPositionEnum} from "modules/enums";
import {IPlayerPoolFilters} from "modules/types";

export interface IPlayerPoolReducer {
	isOpen: boolean;
	isOpenFilters: boolean;
	filters: IPlayerPoolFilters;
}

const initial: IPlayerPoolReducer = {
	isOpen: false,
	isOpenFilters: true,
	filters: {
		value: "",
		position: 0,
		team: 0,
		stats: 0,
	},
};

const onSetIsOpenPlayerPool = (state: IPlayerPoolReducer, payload: boolean) => ({
	...state,
	isOpen: payload,
});

const onUpdatePlayerPoolFilters = (state: IPlayerPoolReducer, payload: IPlayerPoolFilters) => ({
	...state,
	filters: payload,
});

const onSetPlayerPoolFilterPosition = (state: IPlayerPoolReducer, payload: PlayerPositionEnum) => ({
	...state,
	filters: {
		...state.filters,
		position: payload,
	},
});

const onClearPlayerPoolState = () => ({
	...initial,
});

export const playerPoolReducer = createReducer<IPlayerPoolReducer>({}, initial)
	.on(setIsOpenPlayerPool, onSetIsOpenPlayerPool)
	.on(updatePlayerPoolFilters, onUpdatePlayerPoolFilters)
	.on(setPlayerPoolFilterPosition, onSetPlayerPoolFilterPosition)
	.on(clearPlayerPoolState, onClearPlayerPoolState);
